import ScaleLoader from "react-spinners/ScaleLoader";

const Spinner = () => {

  return (
      <div style={{ backgroundColor:'black', display: 'flex', minHeight: 'calc(100vh)', alignItems: 'center',justifyContent: 'center'}}>
         <ScaleLoader  color='#007BFF' loading={true}  />
      </div>
  )
};


export default Spinner;